import { derinApiClient } from "./setup";
import { DerinApiResponse, DerinOrganizationMember, DerinUserRole } from "./interface";

export const getOrganizationMembers = async (
  organizationId: string
): Promise<DerinOrganizationMember[]> => {
  const response = await derinApiClient().get<DerinApiResponse<DerinOrganizationMember[]>>(
    `/organization/${organizationId}/members`
  );
  return response.data.data;
};

/** Gives an existing user access to the organization. */
export const addOrganizationMember = async (
  organizationId: string,
  userId: string,
  role: DerinUserRole
): Promise<void> => {
  await derinApiClient().post(`/organization/${organizationId}/members`, { userId, role });
};

export const updateOrganizationMemberRole = async (
  organizationId: string,
  userId: string,
  role: DerinUserRole
): Promise<void> => {
  await derinApiClient().patch(`/organization/${organizationId}/members/${userId}`, { role });
};

/** Removes the user from this organization only; the account and other memberships stay. */
export const removeOrganizationMember = async (
  organizationId: string,
  userId: string
): Promise<void> => {
  await derinApiClient().delete(`/organization/${organizationId}/members/${userId}`);
};
